'use client';

import { useQuery } from '@tanstack/react-query';

import { codeSessionsAccessOptions } from './queries';

/** Whether the signed-in user can use /code; false until access loads. */
export function useHasCodeAccess(): boolean {
  const { data } = useQuery(codeSessionsAccessOptions());
  return (data?.length ?? 0) > 0;
}

/**
 * Whether the signed-in user can use /code on the installation, or undefined until both the
 * installation and the user's access are known. Access that fails to load counts as none.
 */
export function useHasCodeAccessOnInstallation(
  installationId: number | null,
  options: { enabled?: boolean } = {},
): boolean | undefined {
  const { data, isPending, isError } = useQuery({
    ...codeSessionsAccessOptions(),
    enabled: options.enabled !== false,
  });
  if (isError) {
    return false;
  }
  if (installationId === null || isPending) {
    return undefined;
  }
  return data?.includes(installationId) ?? false;
}
